/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { Reveal as l } from "@progress/kendo-react-animation";
import { useLocalization as i } from "@progress/kendo-react-intl";
import { columnMenuFilterClearButton as m, messages as o, columnMenuFilterSubmitButton as r } from "../messages/index.mjs";
import { Button as a } from "@progress/kendo-react-buttons";
const c = (t) => /* @__PURE__ */ e.createElement("div", { className: "k-columnmenu-item-content" }, /* @__PURE__ */ e.createElement(l, { style: { position: "relative", display: "block" } }, t.show && /* @__PURE__ */ e.createElement("div", { className: "kendo-grid-filter-menu-container" }, /* @__PURE__ */ e.createElement("form", { className: "k-filter-menu", onSubmit: t.onSubmit, onReset: t.onReset }, /* @__PURE__ */ e.createElement("div", { className: "k-filter-menu-container" }, t.children, /* @__PURE__ */ e.createElement("div", { className: "k-actions k-hstack k-justify-content-stretch" }, t.actions)))))), g = (t) => {
  const n = i();
  return /* @__PURE__ */ e.createElement(
    c,
    {
      ...t,
      actions: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(a, { type: "reset" }, n.toLanguageString(m, o[m])), /* @__PURE__ */ e.createElement(a, { themeColor: "primary" }, n.toLanguageString(r, o[r])))
    }
  );
};
export {
  g as ColumnMenuFilterForm,
  c as ColumnMenuForm
};
